"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportDataService = void 0;
var _reportdata = require("../controllers/reportdata.controller");
var ReportDataService = {
  fund: {
    fund: _reportdata.config.fund,
    details: _reportdata.config.fund + "/details",
    list: _reportdata.config.fund + "/list",
    fiscalYear: _reportdata.config.fund + "/fiscal-year",
    uniqueReferenceNo: _reportdata.config.fund + "/unique/reference-no",
    typeList: _reportdata.config.fund + "/type/list",
    deleteAll: _reportdata.config.fund + "/delete-all",
    softDelete: _reportdata.config.fund + "/delete/soft",
    softDeleteRestore: _reportdata.config.fund + "/delete/soft/restore",
    softDeleteList: _reportdata.config.fund + "/list/soft/deleted"
  },
  year: {
    list: _reportdata.config.year + "/list"
  },
  fundBulk: {
    delete: _reportdata.config.fund + "/bulk/delete",
    softDelete: _reportdata.config.fund + "/bulk/delete/soft",
    restore: _reportdata.config.fund + "/bulk/delete/soft/restore"
  },
  donors: {
    donors: _reportdata.config.donors,
    bulkHardDelete: _reportdata.config.donors + "/bulk/hard/delete",
    list: _reportdata.config.donors + "/list",
    deleteAll: _reportdata.config.donors + "/delete-all",
    softDelete: _reportdata.config.donors + "/delete/soft",
    softDeleteRestore: _reportdata.config.donors + "/delete/soft/restore",
    softDeleteList: _reportdata.config.donors + "/list/soft/deleted",
    bulkSoftDelete: _reportdata.config.donors + "/bulk/delete/soft",
    bulkRestore: _reportdata.config.donors + "/bulk/delete/soft/restore"
  },
  impact: {
    impact: _reportdata.config.impact,
    list: _reportdata.config.impact + "/list",
    criteriaList: _reportdata.config.impact + "/criteria/list",
    typeList: _reportdata.config.impact + "/type/list",
    deleteAll: _reportdata.config.impact + "/delete-all",
    sequence: _reportdata.config.impact + "/panel-sequence",
    softDelete: _reportdata.config.impact + "/delete/soft",
    softDeleteRestore: _reportdata.config.impact + "/delete/soft/restore",
    softDeleteList: _reportdata.config.impact + "/list/soft/deleted",
    bulkSoftDelete: _reportdata.config.impact + "/bulk/delete/soft",
    bulkHardDelete: _reportdata.config.impact + "/bulk/hard/delete",
    bulkRestore: _reportdata.config.impact + "/bulk/delete/soft/restore",
    uniqueReferenceNo: _reportdata.config.impact + "/unique/impact-reference-no"
  },
  performance: {
    performance: _reportdata.config.performance,
    list: _reportdata.config.performance + "/list",
    deleteAll: _reportdata.config.performance + "/delete-all",
    softDelete: _reportdata.config.performance + "/delete/soft",
    softDeleteRestore: _reportdata.config.performance + "/delete/soft/restore",
    softDeleteList: _reportdata.config.performance + "/list/soft/deleted",
    bulkRestore: _reportdata.config.performance + "/bulk/delete/soft/restore",
    bulkHardDelete: _reportdata.config.performance + "/bulk/hard/delete"
  },
  impactType: {
    list: _reportdata.config.impactType + "/list",
    fetch: _reportdata.config.impactType,
    add: _reportdata.config.impactType,
    update: _reportdata.config.impactType,
    delete: _reportdata.config.impactType,
    paletteList: _reportdata.config.impactType + "/palette/list",
    softDelete: _reportdata.config.impactType + "/delete/soft",
    softDeleteRestore: _reportdata.config.impactType + "/delete/soft/restore",
    softDeletedList: _reportdata.config.impactType + "/list/soft/deleted",
    bulkSoftDelete: _reportdata.config.impactType + "/bulk/delete/soft",
    bulkHardDelete: _reportdata.config.impactType + "/bulk/delete/hard",
    bulkRestore: _reportdata.config.impactType + "/bulk/delete/soft/restore"
  },
  fundType: {
    list: _reportdata.config.fundType + "/list",
    add: _reportdata.config.fundType,
    update: _reportdata.config.fundType,
    delete: _reportdata.config.fundType,
    paletteList: _reportdata.config.fundType + "/palette/list",
    softDelete: _reportdata.config.fundType + "/delete/soft",
    softDeleteRestore: _reportdata.config.fundType + "/delete/soft/restore",
    softDeletedList: _reportdata.config.fundType + "/list/soft/deleted",
    bulkSoftDelete: _reportdata.config.fundType + "/bulk/delete/soft",
    bulkHardDelete: _reportdata.config.fundType + "/bulk/delete/hard",
    bulkRestore: _reportdata.config.fundType + "/bulk/delete/soft/restore"
  },
  reportingYear: {
    reportNotExistList: _reportdata.config.year + "/list/not-existing",
    reportingYearFindsCurrentFiscalYear: _reportdata.config.year + "/current",
    list: _reportdata.config.year + "/list",
    add: _reportdata.config.year,
    deleteList: _reportdata.config.year + "/list/delete-report-data"
  }
};
exports.ReportDataService = ReportDataService;